<template>
  <!-- 二维地图功能面板 -->
  <div  :class=" allEyesModel?'featurePanel_eyeshield':'featurePanel'">
<!--    <div class="openLeft" v-show="!openLeft" @click="handelOpenLeft">-->
<!--      <img src="../../assets/img/2dmap/open.png" alt="" />-->
<!--    </div>-->
    <div class="taskContentAll" v-if="openLeft">
      <div class="contentItem65" >
        <div class="itemTitle">
          <div class="itemTitleText">飞行活动</div>
        </div>
        <div class="taskcontent_2d" >
          <div  :class="allEyesModel?'taskSearchBox_eyeshield':'taskSearchBox'">
            <el-input
              placeholder="飞机型号,驾驶员,执照号,运营人,备注"
              v-model="searchTaskKeyWord "
              @keyup.enter.native="searchClick"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
            </el-input>
          </div>

          <div class="listAll_2d" v-if="taskList.length !== 0">
            <div
              class="task-item_2d"
              v-for="item in taskList"
              :key="item.id"
              :title="'飞机号:'+item.uavSerial"
              @click="positPlane(item)"
            >
              <div class="donePlan common" v-if="item.status==13||item.status==14">
                <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                <div class="secondSpan" >{{ item.pilot }}</div>
                <div class="thirdSpan" >
                  {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                </div>
                <div style="color: #ee3f3f">已执行</div>
                <div class="itemDetail"></div>
              </div>
              <div class="executePlan common" v-if="item.status==10||item.status==11||item.status==12">
                <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                <div class="secondSpan" >{{ item.pilot }}</div>
                <div class="thirdSpan" >
                  {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                </div>
                <div style="color: #00ffff">执行中</div>
                <div class="itemDetail"></div>
              </div>
              <div class="prePlan common" v-if="item.status==0||item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==7||item.status==8||item.status==9">
                <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                <div class="secondSpan" >{{ item.pilot }}</div>
                <div class="thirdSpan" >
                  {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                </div>
                <div style="color: #00aeff">待执行</div>
                <div class="itemDetail"></div>
              </div>

            </div>
          </div>
          <div class="emptyWrap" v-if="taskList.length == 0">
            <Empty  />
          </div>
        </div>
      </div>
      <div class="eventWrap itemWrapBox35">
        <div class="itemTitle">
          <div class="itemTitleText">实时事件</div>
        </div>
        <div class="contentWrap">
          <div class="taskcontent_2d">
            <div class="listAll_2d"  style="min-height: 180px;overflow: initial" v-if="realTask.length !== 0">
              <div
                class="task-item_2d_realTask"
                :class="item.warning ? 'warn_2d' : 'alarm_2d'"
                v-for="item in realTask"
                @click="positTask(item)"
              >
                <div class="firstSpan">{{ item.warnMes }}</div>
              </div>

            </div>
            <div class="emptyWrap" v-if="realTask.length == 0"> <Empty :allEyesModel="allEyesModel"></Empty></div>
          </div>
        </div>
      </div>
    </div>
    <PlanDetail  :taskForm="taskForm" :clickButton="clickButton"   @update:dialogVisible="updateDialogVisible" @closeForm="closeForm"
    ></PlanDetail>
  </div>
</template>
<script>
import { wgs84ToGcj02 } from "../../../src/assets/js/map/ConverseLngAndLa";
import PlanDetail from "../../common/PlanDetail.vue";
import Empty from "../../common/Empty.vue";
export default {
  props: {
    //护眼模式
    allEyesModel:{
      type: Boolean,
      default: false
    },
    infoArr: {
      type: Array,
      default: []
    },

    realTask: {
      type: Array,
      default: []
    },
    taskList: {
      type: Array,
      default: []
    },
    // 接收父组件传递的方法
    planeWay: {
      type: Function,
      default: null
    },
    showSign: {
      type: Function,
      default: null
    },
    deleteShowSign: {
      type: Function,
      default: null
    },
    planeAllWay: {
      type: Function,
      default: null
    },
    deletePlaneAllWay: {
      type: Function,
      default: null
    },
    airSpace: {
      type: Function,
      default: null
    },
    daleteAirSpace: {
      type: Function,
      default: null
    },
    airPort: {
      type: Function,
      default: null
    },
    daleteAirPort: {
      type: Function,
      default: null
    },
    positionPoint: {
      type: Function,
      default: null
    },
    openLeft: {
      type: Boolean,
      default: true
    },
    showWeather: {
      type: Boolean,
      default: true
    }

  },
  watch:{
    runTask(){
      this.changeRunTask = this.runTask.map(v=>({...v,startChecked:false,changeChecked:false,downChecked:false}))
    }
  },
  components:{PlanDetail,Empty},
  data() {
    return {
      searchTaskKeyWord:'',
      // 存储被点击的id
      startIds:[],
      changeIds:[],
      downIds:[],
      taskForm:{},
      clickButton:false,
      //处理之后的数据
      changeRunTask:[],
      realTask1:[
        {warning:1,warnMes:'2024年11月30日14:35分FC30发生偏航预警'},
        {warning:0,warnMes:'2024年11月30日14:38分FC30发生偏航告警'},
        {warning:1,warnMes:'2024年12月2日15:28分FC30发生偏航预警'},
        {warning:1,warnMes:'2024年12月2日15:29分M3TD发生偏航预警'},
        {warning:1,warnMes:'2024年12月2日15:32分FC30和M3TD发生冲突预警'},
      ],
      // active1: false,
      // active2: false,
      // active3: false,
      // active4: false,
      // active5: false,
      // active6: false,
      openDetail: true,
      searchDoneTask:'',
      searchRealTask:'',
      searchPreTask:'',

    };
  },
  mounted() {
  },
  methods: {
    searchClick(){
      this.$emit('search-item',this.searchTaskKeyWord)
    },
    updateDialogVisible(newVal){
      this.clickButton = newVal
    },
    closeForm(value){
      this.clickButton = value
    },
    positPlane(info) {
      this.taskForm = info
      this.clickButton = true
      if (this.infoArr.length > 0) {
        var foundObject = this.infoArr.find(function(item) {
          return item.id === info.planSerial;
        });
        if (foundObject) {
          let point = {
            longitude: foundObject.longtitude,
            latitude: foundObject.latitude
          };
          this.positionPoint(point);
        }
      }
    },
    handelOpenLeft(){
      this.$emit('handle-openLeft')
    },
    positTask(info) {
      if (this.infoArr.length > 0) {
        var foundObject = this.infoArr.find(function(item) {
          return item.uasID === info.uasID;
        });
        let point = {
          longitude: foundObject.longtitude,
          latitude: foundObject.latitude
        };
        this.positionPoint(point);
      }
    },
    positWay(item) {
      //显示所有航线就定位，否则画出航线并定位
      if (!this.active3) {
        let airLineData = [];
        let points = [];
        item.airpointList.forEach(airpoint => {
          let point = wgs84ToGcj02(airpoint.longitude, airpoint.latitude);
          airLineData.push([point[1], point[0]]);
          points.push({
            po: [point[1], point[0]],
            name: airpoint.name
          });
        });
        // rgba(181, 133 ,0,0.5)
        this.planeWay(airLineData, points, "rgba(14, 29, 192,0.5)", "position");
      }
      this.positionPoint(item.airpointList[0]);
    },
  }
};
</script>

<style scoped>
  @import "../../assets/css/home/FeaturePanel.scss";
</style>c


// WEBPACK FOOTER //
// src/components/home/FeaturePanel.vue